const policeData = require('./data/police.json')
const LAPoliceData = require('./data/LAPolice.json')
const countryData = require('./data/countries.json')
const countyData = require('./data/counties.json')
const LAParishData = require('./data/LAParishes.json')
const stateAndAbbrevData = require('./data/usaStates.json')
// const topCountries = [
//   { 'value': 'USA', 'text': 'United States' },
//   { 'value': 'MEX', 'text': 'Mexico' }
// ]

const cacData = require('./data/cac.json')
const LACacData = require('./data/LACac.json')

const noteTypes = require('./data/noteTypes.json')

const { LABOR_SCREENING_CONCLUSION, LABOR_CONCLUSION_LABEL_MAP, TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP } = require('../helpers/enums')
const {
  NOT_ENOUGH_INFO,
  LEVEL1,
  LEVEL2
} = LABOR_SCREENING_CONCLUSION
const industryRelatedOptions = [
  { value: 'Construction', text: 'Construction' },
  { value: 'Illicit Massage Business', text: 'Illicit Massage Business' },
  { value: 'Agriculture', text: 'Agriculture' },
  { value: 'Landscaping & Groundskeeping', text: 'Landscaping & Groundskeeping' },
  { value: 'Hotel & Hospitality', text: 'Hotel & Hospitality' },
  { value: 'Restaurant & Food Services', text: 'Restaurant & Food Services' },
  { value: 'Domestic Work', text: 'Domestic Work' },
  { value: 'Traveling Sales Crews', text: 'Traveling Sales Crews' }
]

industryRelatedOptions.sort((a, b) => {
  return (a.value > b.value) ? 1 : -1
})

stateAndAbbrevData.items.sort((a, b) => {
  return (a.text > b.text) ? 1 : -1
})
countyData.items.sort((a, b) => {
  return (a.text > b.text) ? 1 : -1
})
LAParishData.items.sort((a, b) => {
  return (a.text > b.text) ? 1 : -1
})
LAPoliceData.items.sort((a, b) => {
  return (a.text > b.text) ? 1 : -1
})

// initial state
const state = {
  stateAndAbbrev: stateAndAbbrevData.items,
  counties: countyData.items,
  LAParishes: LAParishData.items,
  countries: countryData.items,
  months: [
    { value: null, text: 'Select a Month' },
    { value: '1', text: 'January' },
    { value: '2', text: 'February' },
    { value: '3', text: 'March' },
    { value: '4', text: 'April' },
    { value: '5', text: 'May' },
    { value: '6', text: 'June' },
    { value: '7', text: 'July' },
    { value: '8', text: 'August' },
    { value: '9', text: 'September' },
    { value: '10', text: 'October' },
    { value: '11', text: 'November' },
    { value: '12', text: 'December' }
  ],

  gender_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Male', text: 'Male' },
    { value: 'Female', text: 'Female' },
    { value: 'Unknown', text: 'Unknown' },
    { value: 'Other', text: 'Other' }
  ],

  gender_identity: [
    { value: '', text: 'Please select an option' },
    { value: 'Female', text: 'Female' },
    { value: 'Male', text: 'Male' },
    { value: 'Non-binary', text: 'Non-binary' },
    { value: 'Transgender', text: 'Transgender' },
    { value: 'Unknown', text: 'Unknown' },
    { value: 'Other', text: 'Other' }
  ],

  services_provided: [
    { value: '  Addiction Recovery Services', text: '  Addiction Recovery Services' },
    { value: 'Apply for Federal/State Benefits', text: 'Apply for Federal/State Benefits' },
    { value: 'Budget or Financial Literacy', text: 'Budget or Financial Literacy' },
    { value: 'Case Management', text: 'Case Management' },
    { value: 'Child Care', text: 'Child Care' },
    { value: 'Education', text: 'Education' },
    { value: 'Family Unification', text: 'Family Unification' },
    { value: 'Food/Clothing/Hygiene', text: 'Food/Clothing/Hygiene' },
    { value: 'Forensic Interview', text: 'Forensic Interview' },
    { value: 'Health', text: 'Health' },
    { value: 'Housing', text: 'Housing' },
    { value: 'Job Training', text: 'Job Training' },
    { value: 'Legal Services', text: 'Legal Services' },
    { value: 'Mental Health', text: 'Mental Health' },
    { value: 'Mentorship', text: 'Mentorship' },
    { value: 'Multidisciplinary Team Staffing', text: 'Multidisciplinary Team Staffing' },
    { value: 'Other Financial Assistance', text: 'Other Financial Assistance' },
    { value: 'Parenting or Pregnancy Services', text: 'Parenting or Pregnancy Services' },
    { value: 'Personal Documents Assistance', text: 'Personal Documents Assistance' },
    { value: 'Referral to Community Services', text: 'Referral to Community Services' },
    { value: 'Safety Planning', text: 'Safety Planning' },
    { value: 'Translation or ESL Services', text: 'Translation or ESL Services' },
    { value: 'Transportation', text: 'Transportation' },
    { value: 'Victim Advocacy', text: 'Victim Advocacy' },
    { value: 'Victim Compensation', text: 'Victim Compensation' },
    { value: 'Other Services', text: 'Other Services' }
  ],

  race_options: [
    { value: '', text: 'Please select an option' },
    { value: 'American Indian or Alaska Native', text: 'American Indian or Alaska Native' },
    { value: 'Asian', text: 'Asian' },
    { value: 'African American or Black', text: 'African American or Black' },
    { value: 'Middle Eastern or North African', text: 'Middle Eastern or North African' },
    { value: 'Multiracial', text: 'Multiracial' },
    { value: 'Native Hawaiian or Other Pacific Islander', text: 'Native Hawaiian or Other Pacific Islander' },
    { value: 'White or Caucasian', text: 'White or Caucasian' },
    { value: 'Unknown', text: 'Unknown' },
    { value: 'Other', text: 'Other' }
  ],

  ethnicity_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Hispanic or Latino', text: 'Hispanic or Latino' },
    { value: 'Not Hispanic or Latino', text: 'Not Hispanic or Latino' },
    { value: 'Unknown', text: 'Unknown' }
  ],

  immigration_options: [
    { value: '', text: 'Please select an option' },
    { value: 'U.S. Citizen', text: 'U.S. Citizen' },
    { value: 'Lawful Permanent Resident', text: 'Lawful Permanent Resident' },
    { value: 'Temporary Visitor', text: 'Temporary Visitor' },
    { value: 'Undocumented Immigrant', text: 'Undocumented Immigrant' },
    { value: 'Unknown', text: 'Unknown' }
  ],

  orientation_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Bisexual', text: 'Bisexual' },
    { value: 'Gay', text: 'Gay' },
    { value: 'Lesbian', text: 'Lesbian' },
    { value: 'Heterosexual', text: 'Heterosexual' },
    { value: 'Asked but unknown', text: 'Asked but unknown' },
    { value: 'Unknown', text: 'Unknown' },
    { value: 'Other', text: 'Other' }
  ],

  discharge_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Aged out (reached age 18)', text: 'Aged out (reached age 18)' },
    { value: 'Client moved out of service jurisdiction', text: 'Client moved out of service jurisdiction' },
    { value: 'Client returned to trafficker', text: 'Client returned to trafficker' },
    { value: 'Completed service', text: 'Completed service' },
    { value: 'No longer chooses to work with the organization', text: 'No longer chooses to work with the organization' },
    { value: 'Returned to family', text: 'Returned to family' },
    { value: 'Transferred/referred to another service provider', text: 'Transferred/referred to another service provider' },
    { value: 'Unable to locate', text: 'Unable to locate' },
    { value: 'Other reason/Not specified', text: 'Other reason/Not specified' }
  ],

  education_type_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Regular', text: 'Regular' },
    { value: 'SPED', text: 'SPED' },
    { value: '504', text: '504' }
  ],

  poverty_line_options: [
    { value: 'Above', text: 'Above' },
    { value: 'Below', text: 'Below' }
  ],

  victim_status_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Confirmed' },
    { value: 'Suspected', text: 'Suspected' },
    { value: 'At-Risk', text: 'At-Risk' },
    { value: 'Unknown', text: 'Unknown' }
  ],

  victim_status_options_cc: [
    { value: '', text: 'Please select an option' },
    { value: 'Yes', text: 'Confirmed' },
    { value: 'Suspected', text: 'Suspected' },
    { value: 'At-Risk', text: 'At-Risk' },
    { value: 'Other', text: 'Other' }
  ],

  le_called_options: policeData.items,

  le_called_options_la: LAPoliceData.items,

  guardian_options: [
    { value: 'Parent', text: 'Parent' },
    { value: 'CPS', text: 'CPS' },
    { value: 'Other', text: 'Other' }
  ],

  grade_level_options: [
    { value: '', text: 'Please select an option' },
    { value: 'Pre-K', text: 'Pre-K' },
    { value: 'K', text: 'K' },
    { value: '1', text: '1' },
    { value: '2', text: '2' },
    { value: '3', text: '3' },
    { value: '4', text: '4' },
    { value: '5', text: '5' },
    { value: '6', text: '6' },
    { value: '7', text: '7' },
    { value: '8', text: '8' },
    { value: '9', text: '9' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' },
    { value: 'Some high school, no diploma', text: 'Some high school, no diploma' },
    { value: 'High school diploma/GED', text: 'High school diploma/GED' },
    { value: 'Some college credit, no degree', text: 'Some college credit, no degree' },
    { value: 'Trade/technical/vocational training', text: 'Trade/technical/vocational training' },
    { value: 'Associate\'s degree', text: 'Associate\'s degree' },
    { value: 'College/advanced degree', text: 'College/advanced degree' }
  ],

  disability_options: [
    { value: '', text: 'Please select an option' },
    { value: 'None', text: 'None' },
    { value: 'Physical disability', text: 'Physical disability' },
    { value: 'Intellectual disability', text: 'Intellectual disability' },
    { value: 'Both', text: 'Both' },
    { value: 'Unknown', text: 'Unknown' },
    { value: 'Other', text: 'Other' }
  ],

  yesnounknown_options: [
    { value: 'Yes', text: 'Yes' },
    { value: 'No', text: 'No' },
    { value: 'Unknown', text: 'Unknown' },
    { value: 'NA', text: 'NA' }
  ],

  confirmation_source_options: [
    { value: 'Victim Outcry', text: 'Victim Outcry' },
    { value: 'Law Enforcement', text: 'Law Enforcement' },
    { value: 'Medical Professional', text: 'Medical Professional' },
    { value: 'Expert Assessment/Interview', text: 'Expert Assessment/Interview' },
    { value: 'Other', text: 'Other' }
  ],

  types_of_trafficking_tx: [
    { value: 'sex', text: 'Sex Trafficking & Exploitation' },
    { value: 'labor', text: 'Labor Trafficking & Exploitation' },
    { value: 'forced_marriage', text: 'Forced Marriage' }
  ],

  types_of_trafficking_la: [
    { value: 'sex', text: 'Sex Trafficking & Exploitation' },
    { value: 'labor', text: 'Labor Trafficking & Exploitation' }
    ],

  means_of_sex_trafficking: [
    { value: 's_commercial_sex_exploitation_of_child', text: 'Commercial Sexual Exploitation of Child' },
    { value: 's_forced_commercial_sex_exploitation', text: 'Forced Commercial Sexual Exploitation of Adult' },
    { value: 's_familial_facilitated', text: 'Familial or Household Member Facilitated' },
    { value: 's_gang_facilitated', text: 'Gang Facilitated' },
    { value: 's_minor_engaged_in_survival_sex', text: 'Minor Engaged in Survival Sex' }
  ],

  means_of_labor_trafficking: [
    { value: 'l_domestic_servitude', text: 'Domestic Servitude' },
    { value: 'l_familial_facilitated', text: 'Familial or Household Member Facilitated' },
    { value: 'l_gang_facilitated', text: 'Gang Facilitated' },
    { value: 'l_industry_related', text: 'Industry Related' }
  ],

  industry_related_options: [
    { value: '', text: 'Please select an option' },
    ...industryRelatedOptions,
    { value: 'Other', text: 'Other' }
  ],

  is_super_admin_options: [
    { value: true, text: 'Yes' },
    { value: false, text: 'No' }
  ],

  is_owning_group_options: [
    { value: true, text: 'True' },
    { value: false, text: 'False' }
  ],

  runaway_options: [
    { value: '2 times', text: '2 times' },
    { value: '3 times', text: '3 times' },
    { value: '4 times', text: '4 times' },
    { value: '5 or more times', text: '5 or more times' }

  ],

  cac_options: cacData.items,
  cac_options_la: LACacData.items,

  assessment_indicator_options: [
    { value: 'All', text: 'All Lighthouse Indicators' },
    { value: '0', text: 'Not Enough Information' },
    { value: '1', text: 'Possible Victim' }
  ],

  cseit_indicator_options: [
    { value: 'All', text: 'All Screenings' },
    { value: 'No Concern', text: 'No Concern' },
    { value: 'Possible Concern', text: 'Possible Concern' },
    { value: 'Clear Concern', text: 'Clear Concern' }
  ],

  laborscreening_indicator_options: [
    { value: 'All', text: 'All Screenings' },
    { value: NOT_ENOUGH_INFO, text: LABOR_CONCLUSION_LABEL_MAP[NOT_ENOUGH_INFO] },
    { value: LEVEL1, text: LABOR_CONCLUSION_LABEL_MAP[LEVEL1] },
    { value: LEVEL2, text: LABOR_CONCLUSION_LABEL_MAP[LEVEL2] }
  ],

  traffickingscreening_indicator_options: [
    { value: 'All', text: 'All Screenings' },
    { value: NOT_ENOUGH_INFO, text: TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP['0'] },
    { value: LEVEL1, text: TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP['1'] },
    { value: LEVEL2, text: TRAFFICKING_SCREENING_CONCLUSION_LABEL_MAP['2'] }
  ],

  person_biographic_options: [
    { value: 'b_birthdate', text: 'Age' },
    // { value: 'b_approximate_age', text: 'Approximate Age' },
    { value: 'p_country_of_origin', text: 'Country of Origin' },
    { value: 'p_cps_called', text: 'CPS Called' },
    { value: 'b_disability', text: 'Disability' },
    { value: 'p_grade_level', text: 'Education Level' },
    { value: 'p_education_type', text: 'Education Type' },
    // { value: 'b_confirmation_source', text: 'Confirmation Source' },
    { value: 'b_ethnicity', text: 'Ethnicity' },
    { value: 'p_forcedlabor', text: 'Forced Labor' },
    { value: 'p_gang_affiliation', text: 'Gang Affiliation' },
    { value: 'b_gender', text: 'Gender at Birth' },
    { value: 'b_gender_identity', text: 'Gender Identity' },
    // { value: 'p_imm_status', text: 'Immigration Status' },
    { value: 'b_immigration_category', text: 'Immigration Status' },
    { value: 'p_le_called', text: 'LE Called' },
    { value: 'p_outcry', text: 'Outcry' },
    { value: 'p_perpetrator_known', text: 'Perpetrator Known' },
    { value: 'p_poverty_line', text: 'Poverty Line' },
    { value: 'b_race', text: 'Race' },
    { value: 'p_runaway', text: 'Runaway' },
    { value: 'p_runaway_frequency', text: 'Runaway Frequency' },
    { value: 'b_orientation', text: 'Sexual Orientation' },
    // { value: 'p_street_name', text: 'Street Name' },
    // { value: 'p_presenting_offense', text: 'Presenting Offense' },
    { value: 'p_social_media', text: 'Social media' },
    { value: 'p_substance_use', text: 'Substance Use' },
    { value: 'p_tattoos', text: 'Tattoos' }
    // { value: 'd_social_media', text: '' },
    // { value: 'p_le_call_date', text: '' },
    // { value: 'p_le_agency', text: 'LE Agency' },
    // { value: 'p_perpetrator_name', text: '' },
    // { value: 'p_cps_call_date', text: '' },
    // { value: 'p_cps_id_number', text: '' },
    // { value: 'p_cps_reference_number', text: '' },
    // { value: 'p_cac_interview', text: '' },
    // { value: 'p_cac_call_date', text: '' },
    // { value: 'p_cac_agency', text: 'CAC Agency' },
    // { value: 'p_internet_involved', text: 'Internet Involved' },
    // { value: 'p_gang_description', text: '' },
    // { value: 'p_guardian', text: '' },
    // { value: 'p_last_home_location', text: '' },
    // { value: 'p_tattoo_description', text: '' },
    // { value: 'b_additional_info', text: '' },
    // { value: 'p_substance_use_description', text: '' },
    // { value: 'p_tattoo_photo', text: '' }
  ],

  presenting_offense_options: [
    { value: 'Assault', text: 'Assault' },
    { value: 'Assault on a Family Member', text: 'Assault on a Family Member' },
    { value: 'Burglary of a Habitation', text: 'Burglary of a Habitation' },
    { value: 'Criminal Trespass', text: 'Criminal Trespass' },
    { value: 'Possession of a Controlled Substance', text: 'Possession of a Controlled Substance' },
    { value: 'Robbery', text: 'Robbery' },
    { value: 'Runaway', text: 'Runaway' },
    { value: 'Theft', text: 'Theft' },
    { value: 'Other', text: 'Other' }
  ],

  note_types: noteTypes.items
}

// getters
const getters = {
  getOrientationOptions: state => state.orientation_options,
  getVictimStatusOptions: state => state.victim_status_options,
  getVictimStatusOptionsForCC: state => state.victim_status_options_cc,
  getRaceOptions: state => state.race_options,
  getDischargeOptions: state => state.discharge_options,
  getServicesProvided: state => state.services_provided,
  getEthnicityOptions: state => state.ethnicity_options,
  getGenderIdentityOptions: state => state.gender_identity,
  getGenderOptions: state => state.gender_options,
  getImmigrationOptions: state => state.immigration_options,
  getMonths: state => state.months,
  getCountries: state => state.countries,
  getEducationTypeOptions: state => state.education_type_options,
  getPovertyLineOptions: state => state.poverty_line_options,
  getLeCalledOptions: state => state.le_called_options,
  getLALeCalledOptions: state => state.le_called_options_la,
  getGuardianOptions: state => state.guardian_options,
  getPresentingOffenseOptions: state => state.presenting_offense_options,
  getGradeLevelOptions: state => state.grade_level_options,
  getConfirmationSourceOptions: state => state.confirmation_source_options,
  getRunawayOptions: state => state.runaway_options,
  getCacOptions: state => state.cac_options,
  getLACacOptions: state => state.cac_options_la,
  getPersonBiographicOptions: state => state.person_biographic_options,
  getNoteTypes: state => state.note_types,
  getIsSuperAdminOptions: state => state.is_super_admin_options,
  getIsOwningGroupOptions: state => state.is_owning_group_options,
  getDisabilityOptions: state => state.disability_options,
  getYesNoUnknownOptions: state => state.yesnounknown_options,
  getAssessmentIndicatorOptions: state => state.assessment_indicator_options,
  getCseitIndicatorOptions: state => state.cseit_indicator_options,
  getLaborScreeningIndicatorOptions: state => state.laborscreening_indicator_options,
  getTraffickingScreeningIndicatorOptions: state => state.traffickingscreening_indicator_options,
  getStateAndAbbrev: state => state.stateAndAbbrev,
  getCountyData: state => state.counties,
  getTraffickingTypesTX: state => state.types_of_trafficking_tx,
  getTraffickingTypesLA: state => state.types_of_trafficking_la,
  getSexTraffickingMeans: state => state.means_of_sex_trafficking,
  getLaborTraffickingMeans: state => state.means_of_labor_trafficking,
  getIndustryRelatedOptions: state => state.industry_related_options,
  getLAParishData: state => state.LAParishes
}

// actions
const actions = {
}

// mutations
const mutations = {
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/fieldOptions.js